/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S11_Sipay_LabelInputs */

const tr_mesafeli_s11_sipay_label = /** @type {(inputs: Mesafeli_S11_Sipay_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sipay Elektronik Para ve Ödeme Hizmetleri A.Ş. (TR):`)
};

const en_mesafeli_s11_sipay_label = /** @type {(inputs: Mesafeli_S11_Sipay_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sipay Elektronik Para ve Ödeme Hizmetleri A.Ş. (TR):`)
};

const de_mesafeli_s11_sipay_label = /** @type {(inputs: Mesafeli_S11_Sipay_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sipay Elektronik Para ve Ödeme Hizmetleri A.Ş. (TR):`)
};

const ru_mesafeli_s11_sipay_label = /** @type {(inputs: Mesafeli_S11_Sipay_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sipay Elektronik Para ve Ödeme Hizmetleri A.Ş. (TR):`)
};

/**
* | output |
* | --- |
* | "Sipay Elektronik Para ve Ödeme Hizmetleri A.Ş. (TR):" |
*
* @param {Mesafeli_S11_Sipay_LabelInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s11_sipay_label = /** @type {((inputs?: Mesafeli_S11_Sipay_LabelInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S11_Sipay_LabelInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s11_sipay_label(inputs)
	if (locale === "de") return de_mesafeli_s11_sipay_label(inputs)
	if (locale === "ru") return ru_mesafeli_s11_sipay_label(inputs)
	return tr_mesafeli_s11_sipay_label(inputs)
});